/**
 * @method 用来本地存储和取值删除功能,传一个值是get两个值是set
 * @param {string} key 本地存键key值
 * @param {string} val 存储的值 传null值相当于清除函数
 */
export const cache = (key, val) => {
  if (val || val === null || val === 0) {
    val === null ? localStorage.removeItem(key) : localStorage.setItem(key, val)
  } else {
    return localStorage.getItem(key)
  }
}
export const dataURLtoFile = (dataUrl, filename) => {
  // 获取到base64编码
  let base64Str = dataUrl.split(',')
  // 将base64编码转为字符串
  let decodeStr = atob(base64Str[1])
  let n = decodeStr.length
  // 创建初始化为0的，包含length个元素的无符号整型数组
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = decodeStr.charCodeAt(n)
  }
  return new File([u8arr], filename, {
    type: 'image/jpeg'
  })
}

/**
 * @method 用来本地存储和取值删除功能,传一个值是get两个值是set
 * @param {string} key 本地存键key值
 * @param {string} val 存储的值 传null值相当于清除函数
 */
export const sessionCache = (key, val) => {
  if (val || val === null || val === 0) {
    val === null ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, val)
  } else {
    return sessionStorage.getItem(key)
  }
}

/**
 * @method 用来转化时间戳是时间变成YMDhms自己自由组合的字符串格式
 * @param {number} time 时间戳
 * @param {string} str Y M  D h m s自由组合的字符串随意组合
 */
export const timestampToStr = (time, str) => {
  if (!time) return ''
  const date = new Date(time)
  str = str.replace('Y', date.getFullYear())
  str = str.replace('M', (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1))
  str = str.replace('D', (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()))
  str = str.replace('h', (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()))
  str = str.replace('m', (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()))
  str = str.replace('s', (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()))
  return str
}

/**
 * @method 传入剩余时间把他们转化为时分秒
 * @param {number} num 要转化剩余的毫秒数
 * @param {str} str    转化的格式h m s自由组合的字符串随意组合
*/
export const handleTime = (num, str) => {
  // 剩余总秒数
  num = Math.floor(num / 1000)
  const s = num % 60
  const m = Math.floor((num % 3600) / 60)
  const h = Math.floor(num / 3600)
  str = str.replace('h', (h < 10 ? '0' + h : h))
  str = str.replace('m', (m < 10 ? '0' + m : m))
  str = str.replace('s', (s < 10 ? '0' + s : s))
  return str
}

/**
 *
 * @param {number} timer 需要转化的时间戳
 */
export const changeTime = (timer) => {
  timer = timer || 0
  let str = ''

  let d = Math.floor(timer / (1000 * 60 * 60 * 24))
  let h = Math.floor((timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
  let m = Math.floor((timer % (1000 * 60 * 60)) / (1000 * 60))
  let s = Math.floor((timer % (1000 * 60)) / 1000)

  let day = d === 0 ? '' : d + '天'
  let hou = h < 10 ? '0' + h : h
  let min = m < 10 ? '0' + m : m
  let sec = s < 10 ? '0' + s : s
  str = day + hou + ':' + min + ':' + sec
  return str
}

/**
 * @method 用来数字变中文三位一个逗号
 * @param {number} num 需要数字转中文数字的
 * @return {string}  返回中文数字
 */
export const numberComma = (num) => {
  let str = ''
  let s1 = Math.floor(num / (1000 * 1000))
  let s2 = Math.floor((num % (1000 * 1000)) / 1000)
  let s3 = num % 1000
  if (s1 > 0) {
    let str1 = s1 + ''
    let str2 = s2 === 0 ? '000' : (s2 < 10 ? '00' + s2 : (s2 < 100 ? '0' + s2 : s2 + ''))
    let str3 = s3 === 0 ? '000' : (s3 < 10 ? '00' + s3 : (s3 < 100 ? '0' + s3 : s3 + ''))
    str = str1 + ',' + str2 + ',' + str3
  } else if (s2 > 0) {
    let str2 = s2 + ''
    let str3 = s3 === 0 ? '000' : (s3 < 10 ? '00' + s3 : (s3 < 100 ? '0' + s3 : s3 + ''))
    str = str2 + ',' + str3
  } else {
    str = s3 + ''
  }
  return str
}

/**
 * @method 用来数字变中文数字
 * @param {number} num 需要数字转中文数字的
 * @return {string}  返回中文数字
 */
export const numberChinese = (num) => {
  let str = ''
  switch (num) {
    case 0: str = '零'
      break
    case 1: str = '一'
      break
    case 2: str = '二'
      break
    case 3: str = '三'
      break
    case 4: str = '四'
      break
    case 5: str = '五'
      break
    case 6: str = '六'
      break
    case 7: str = '七'
      break
    case 8: str = '八'
      break
    case 9: str = '九'
      break
  }
  return str
}

/**
 * @method 通过文件名字寻找文件格式
 * @param {String} str 文件名
 * @returns {string}
 */
export const fileFormat = (str) => {
  const formatStr = str.split('.').pop() || ''
  if (formatStr === '') return 'unknown'
  const list = {
    excel: ['xls', 'xlsx'],
    pdf: ['pdf'],
    ppt: ['ppt', 'pptx'],
    word: ['doc', 'docx', 'wps'],
    video: ['mov', 'mp4'],
    zip: ['zip', 'rar'],
    music: ['mp3'],
    img: ['png', 'jpg', 'jpge']
  }
  for (let i in list) {
    if (list[i].indexOf(formatStr) > -1) {
      return i
    }
  }
  return 'unknown'
}

/**
 * @method 去字符串除前后空格
 * @return {String} 需要去除的字符串
 */
export const trim = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}

/**
 * @method 检测是不是app环境
 * @return {boolean} true就是不在app false就是在app中
 */
export const getUserAgent = () => {
  let str = navigator.userAgent
  if (str.indexOf('Bloom_iOS') > -1) {   // ios
    return false
  } else if (str.indexOf('Bloom_Android') > -1) {  // Android
    return false
  } else {
    return true
  }
  // return true
}

/**
 * @method app环境的登录
 */
export const appLogin = () => {
  if (window.webkit) {
    window.webkit.messageHandlers.popLogin.postMessage(null)
  }
  if (window.AndroidJSObject) {
    window.AndroidJSObject.login()
  }
}

/**
 * @method web向app环境的跳转业务
 * @param str string url加参数
 */
export const pushAPP = (str) => {
  let load = document.createElement('a')
  load.href = `sktbloom://push?ID=${str}`
  document.body.appendChild(load)
  load.click()
  document.body.removeChild(load)
}

/**
 * @method 获取当前url某个qurey值
 * @param variable string
 */
export const getQueryVariable = (variable) => {
  let org = window.location.hash.split('?')[1] || ''
  // var query = window.location.search.substring(1)
  var vars = org.split('&')
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split('=')
    if (pair[0] === variable) {
      return pair[1]
    }
  }
  return false
}

/**
 * @method 过滤非法输入
 * @param {String} str 需要过滤的字符串
 * @returns {string}
 */
export const filterInput = (str) => {
  str = str.replace('&', ' &amp;')
  str = str.replace(' ', '&nbsp;')
  str = str.replace('<', '&lt;')
  str = str.replace('>', '&gt;')
  str = str.replace(/\n/g, '<br>')
  return str
}

/** 判断是否为数组
 * @method isArray
 * @param {any} arry
 */
export const isArray = (arry) => {
  return Object.prototype.toString.call(arry) === '[object Array]'
}

export const isMiniProgram = () => {
  var ua = window.navigator.userAgent.toLowerCase()
  // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
  /* eslint-disable */
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    if (window.__wxjs_environment === 'miniprogram') {
      return true
    }
  }
  return false
}

export const timeToStr = (t = 0) => {
  if (isNaN(t)) return ''
  t = Math.floor(t)
  let h = Math.floor(t / 3600)
  let m = Math.floor((t % 3600) / 60)
  let s = t % 60
  h = h > 9 ? h : `0${h}`
  m = m > 9 ? m : `0${m}`
  s = s > 9 ? s : `0${s}`
  if (h === '00') {
    return `${m} : ${s}`
  } else {
    return `${h} : ${m} : ${s}`
  }
}

export const setMiniProgramShare = (shareTitle, imageUrl, shareUrl) => {
  try {
    // 小程序环境下逻辑
    window.wx && window.wx.miniProgram.postMessage({ data: { title: shareTitle, path: shareUrl, imageUrl: imageUrl } })
  } catch (ex) {
    console.log(ex)
  }
}

export const d = (arry) => {
  return Object.prototype.toString.call(arry) === '[object Array]'
}

// base64 转 blob
export const dataURItoBlob = (dataURI) => {
  // convert base64/URLEncoded data component to raw binary data held in a string
  let byteString
  if (dataURI.split(',')[0].indexOf('base64') >= 0) {
    byteString = atob(dataURI.split(',')[1])
  } else byteString = unescape(dataURI.split(',')[1])

  // separate out the mime component
  const mimeString = dataURI
    .split(',')[0]
    .split(':')[1]
    .split(';')[0]

  // write the bytes of the string to a typed array
  const ia = new Uint8Array(byteString.length)
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i)
  }
  return new Blob([ia], { type: mimeString })
}

export const blobToFile = (theBlob, fileName) => {
  theBlob.lastModifiedDate = new Date()
  theBlob.originalFilename = fileName
  theBlob.name = fileName
  return theBlob
}


// WEBPACK FOOTER //
// ./src/assets/js/utils.js